import React from 'react';
import DonutSplitChart from './DonutSplitChart';

// "Pending" is intentionally excluded from this chart per product decision.
const excludePending = (rows) =>
  rows.filter((r) => String(r.name || '').trim().toLowerCase() !== 'pending');

// MSME classification only applies to Indian vendors, so the backend counts
// Indian vendors only. The center total = Indian vendors considered (MSME +
// Non-MSME), which the "INDIAN VENDORS" label makes explicit.
const MsmeSplitChart = () => (
  <DonutSplitChart
    title="Split Over MSME"
    endpoint="/dashboard/msme-split"
    fixedCategories={[{ name: 'Non-MSME' }, { name: 'MSME' }]}
    transform={excludePending}
    cornerLabel="count · %"
    centerLabel="INDIAN VENDORS"
    labelBelow
  />
);

export default MsmeSplitChart;
